import React, { useState, useEffect } from "react";
import { BsLock, BsUnlock } from "react-icons/bs";

import { useNavigate } from "react-router-dom";

export default function AdminLogin() {

  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const login = ()=>{

    if (!username || !password) {
        alert("Please fill in both Username and Password.");
        return;
    }
    
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };
    
    fetch(`https://api.padampura.com/LoginCheck?UID=${username}&Pwd=${password}`, requestOptions)
     .then((response) => response.json())
      .then((result) => {
        if(result.status === true){
          // console.log(result);
          navigate("/Dashboard");
        }else{
          alert('Invalid Credentials')
        }
      })
      .catch((error) => console.error(error));
  }

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-12 m-auto mt-5">
            <div className="card border-1 rounded-1 p-4 login-card">
              <div className="card border-0 rounded-0">
                <div className=" text-center" style={{fontSize: 30, fontWeight: 600, fontfamily: "Poppins", fontStyle: "normal", lineHeight: "normal", color: "#000", }}>Welcome to Admin</div>
                <div className="mt-4">
                  <div className="text-start" style={{ fontSize: 14, fontWeight: 400, fontFamily: "Poppins", color: "#000", }} >Login Id</div>
                  <div class="input-group mb-3" style={{ border: "1px solid #000", borderRadius: 40 }}>
                    <input type="text" value={username} onChange={(e)=> setUsername(e.target.value)} className="form-control ps-4 border-0 bg-transparent input-field-color" placeholder="username" aria-label="Username" aria-describedby="basic-addon1"/>
                    <span className="input-group-text border-0 bg-transparent" id="basic-addon1" style={{ color: "#32A7FC" }}>@</span>
                  </div>
                  <div className="text-start" style={{ fontSize: 14, fontWeight: 400, fontFamily: "Poppins", }}>Password</div>
                  <div class="input-group" style={{ border: "1px solid #000", borderRadius: 40 }}>
                    <input type={showPassword ? "text" : "password"} value={password} onChange={handlePasswordChange} className="form-control ps-4 border-0 bg-transparent input-field-color" placeholder="Enter password" aria-label="Username" aria-describedby="basic-addon2"/>
                    <span onClick={togglePasswordVisibility} className="input-group-text password-toggle border-0 bg-transparent" id="basic-addon2" style={{ color: "#32A7FC" }}>
                      {showPassword ? (<><BsUnlock /></>) : (<><BsLock /></>)}
                    </span>
                  </div>
                  <div className="text-end mb-3" style={{ fontSize: 13, fontWeight: 400, fontFamily: "Poppins", lineHeigth: "normal", fontStyle: "italic", cursor: "pointer", }} >Forgot your password?</div>
                </div>
                <button onClick={()=> {login()}} className="btn-hover color-3 rounded-5 px-4 py-0">Login</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
